// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.wrapper .map_section {
  width: 75%;
  height: 100%;
  transition: ease-in-out 1s;
  position: relative;
}
@media (max-width: 992px) {
  .wrapper .map_section {
    width: 100%;
  }
}
.wrapper .map_section.hide_section {
  width: 0%;
}
.wrapper .sidebar_section {
  padding-top: 20px;
  width: 25%;
  box-shadow: -4.141304493px 0px 56.9429397583px 0px rgba(0, 0, 0, 0.1019607843);
  background-size: cover;
  transition: width 1.5s flex-direction 2s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  transition: ease-in-out 1s;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.wrapper .sidebar_section app-venue-suggestion {
  width: 100%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section {
    width: 0;
  }
  .wrapper .sidebar_section app-venue-suggestion {
    visibility: none;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
}
.wrapper .sidebar_section.full-width {
  padding: 100px 50px;
  transition: all 1s;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}
.wrapper .sidebar_section.full-width .title {
  display: none;
  visibility: none;
  opacity: 0;
  transition: visibility 2s;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width {
    flex-direction: column !important;
    width: 100% !important;
    padding: 100px 20px;
    flex-wrap: nowrap;
  }
}
.wrapper .sidebar_section.full-width app-venue-suggestion {
  width: 24%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width app-venue-suggestion {
    width: 100%;
    opacity: 1;
  }
}

#map {
  width: 100%;
  height: calc(100% - 115px);
  z-index: 0;
}
@media (min-width: 991px) {
  #map {
    height: 100%;
  }
}
#map img {
  z-index: 1;
  max-height: none !important;
  max-width: none !important;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
  width: 100%;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 15px;
}

#search-container {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.search-container-input {
  top: 30px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 100%;
}
@media (max-width: 992px) {
  app-venue-suggestion {
    width: 90%;
  }
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
}

.mode-icon {
  padding: 10px;
  height: 25px;
  width: 25px;
}

.mode-icon {
  background: #f8f8f8;
  fill: var(--ion-color-primary);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  fill: #f8f8f8;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}
.loading-container ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  color: white;
}
@media (min-width: 991px) {
  .loading-container ion-spinner {
    width: 80px;
    height: 80px;
  }
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-venues {
  background: #f8f8f8;
}

.full-height {
  height: 100%;
}

#show_toggler,
#search-container-input {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
  padding: 10px;
  transition: top 1s;
  z-index: 10;
}
@media (max-width: 992px) {
  #show_toggler,
  #search-container-input {
    width: 350px;
    top: 30px;
  }
}
#show_toggler h3,
#search-container-input h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
}
#show_toggler.move_up,
#search-container-input.move_up {
  top: 10px;
}

swiper-slide {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

app-map-search-venue {
  width: 100%;
}

#show_toggler h3 {
  text-transform: uppercase;
  font-size: 16px;
}

.scroll-block {
  max-height: calc(100vh - 95px);
  --background: transparent;
  background: transparent;
  --padding-start: 20px;
  --padding-end: 20px;
}

.enter_address {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  display: flex;
  flex-direction: column;
}
.enter_address.hide-item {
  opacity: 0;
}
@media (max-width: 992px) {
  .enter_address {
    top: 120px;
  }
}
.enter_address .wrapper_input {
  background: white;
  border-radius: 16px;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  width: 100%;
}
.enter_address ion-input {
  font-size: 18px;
  color: var(--ion-color-secondary);
}
.enter_address ion-icon {
  width: 30px;
  height: 30px;
}
.enter_address .pac-container {
  background: white;
  width: 100%;
  padding: 8px 20px !important;
  margin-top: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
  border: none !important;
}
.enter_address .pac-container .pac-item {
  border-top: none !important;
  font-family: Subway, sans-serif;
  padding: 16px 0;
  line-height: 1 !important;
  font-size: 14px !important;
  border-bottom: 0.5px solid #e8e8e8;
}
.enter_address .pac-container .pac-item:last-child {
  border-bottom: none;
}
.enter_address .pac-container .pac-item .pac-matched {
  font-family: Subway-bold, sans-serif;
}

.wrapper_for_types {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  max-height: -moz-fit-content;
  max-height: fit-content;
  position: relative;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
}
.wrapper_for_types .show-error-item {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  background: #ed6958;
  justify-content: center;
  padding: 10px 15px;
  border-radius: 10px;
}
.wrapper_for_types .show-error-item ion-icon {
  position: absolute;
  top: -10px;
}
.wrapper_for_types .show-error-item h3 {
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  color: white;
}
.wrapper_for_types .show-error-item p {
  font-size: 14px;
  color: white;
}
@media (min-width: 991px) {
  .wrapper_for_types.wrapper_for_types_desktop {
    display: none;
  }
}
.wrapper_for_types .item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background: transparent;
}
.wrapper_for_types .item div {
  padding: 10px;
  background: #f3f3f3;
  border-radius: 50%;
  overflow: hidden;
  width: 50px;
  height: 50px;
  transition: background 0.3s ease-in-out;
}
.wrapper_for_types .item div ion-icon {
  width: 30px;
  height: 30px;
  transition: fill 0.3s ease-in-out;
  fill: var(--ion-color-secondary);
}
.wrapper_for_types .item p {
  font-size: 16px;
  margin-top: 10px;
  color: var(--ion-color-secondary);
}
.wrapper_for_types .item.active div {
  background: var(--ion-color-primary);
}
.wrapper_for_types .item.active div ion-icon {
  fill: white;
}

.show-error {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/maps/components/map-venue/map-venue.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;AADD;AAEC;EACC,UAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;AAAF;ACHE;EDDD;IAME,WAAA;EAED;AACF;AADE;EACC,SAAA;AAGH;AAAC;EAaC,iBAAA;EACA,UAAA;EACA,8EAAA;EAEA,sBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAZF;AAbE;EACC,WAAA;AAeH;AC5BE;EDWD;IAKE,QAAA;EAgBD;EAfC;IACC,gBAAA;IACA,UAAA;IAEA,kCAAA;EAgBF;AACF;AACE;EAOC,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AALH;AARG;EACC,aAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AAUJ;ACtDE;EDuCA;IAgBE,iCAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EAGF;AACF;AAFG;EACC,UAAA;AAIJ;ACjEE;ED4DC;IAGE,WAAA;IAEA,UAAA;EAKH;AACF;;AACA;EACC,WAAA;EACA,0BAAA;EAKA,UAAA;AAFD;ACnFE;ED8EF;IAIE,YAAA;EAKA;AACF;AAFC;EACC,UAAA;EACA,2BAAA;EACA,0BAAA;AAIF;;AAAA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AAGD;;AAAA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAGD;;AADA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAID;;AAFA;EACC,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAKD;AAHC;EACC,WAAA;AAKF;;AAFA;EACC,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAKD;;AAHA;EACC,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAMD;;AAHA;EACC,oBAAA;AAMD;;AAHA;EACC,WAAA;AAMD;AChJE;EDyIF;IAGE,UAAA;EAQA;AACF;;AANA;EACC,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AASD;;AAPA;EACC,YAAA;AAUD;;AAPA;EACC,aAAA;EACA,YAAA;EACA,WAAA;AAUD;;AAPA;EACC,mBAAA;EACA,8BAAA;EACA,uBAAA;AAUD;;AAPA;EACC,oCAAA;EACA,aAAA;EACA,uBAAA;AAUD;;AAPA;EACC,YAAA;AAUD;;AAPA;EAKC,cAAA;EACA,YAAA;AAMD;AAXC;EACC,gBAAA;AAaF;AAPC;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AASF;;AANA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AASD;AARC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAUF;AC7NE;ED4MD;IASE,WAAA;IACA,YAAA;EAYD;AACF;;AARA;EACC,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAWD;AATC;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAWF;AARC;EACC,eAAA;AAUF;AAPC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AASF;;AALA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAQD;;AALA;EACC,mBAAA;AAQD;;AANA;EACC,YAAA;AASD;;AAPA;;EAEC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wDAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAUD;ACjRE;EDyPF;;IAgBE,YAAA;IACA,SAAA;EAaA;AACF;AAZC;;EACC,oCAAA;EACA,eAAA;AAeF;AAbC;;EACC,SAAA;AAgBF;;AAbA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AAgBD;;AAdA;EACC,WAAA;AAiBD;;AAdC;EACC,yBAAA;EACA,eAAA;AAiBF;;AAdA;EACC,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAiBD;;AAZA;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AAeD;AAdC;EACC,UAAA;AAgBF;ACrUE;ED4SF;IAYE,UAAA;EAiBA;AACF;AAhBC;EACC,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;AAkBF;AAhBC;EACC,eAAA;EACA,iCAAA;AAkBF;AAhBC;EACC,WAAA;EACA,YAAA;AAkBF;AAhBC;EACC,iBAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,oDAAA;EACA,6BAAA;EACA,uBAAA;AAkBF;AAhBE;EACC,2BAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,kCAAA;AAkBH;AAhBG;EACC,mBAAA;AAkBJ;AAfG;EACC,oCAAA;AAiBJ;;AAZA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EAAA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AAeD;AAdC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAgBF;AAfE;EACC,kBAAA;EACA,UAAA;AAiBH;AAfE;EACC,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;AAiBH;AAfE;EACC,eAAA;EACA,YAAA;AAiBH;AClaE;EDoZD;IAEE,aAAA;EAgBD;AACF;AAbC;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAeF;AAdE;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;AAgBH;AAfG;EACC,WAAA;EACA,YAAA;EACA,iCAAA;EAEA,gCAAA;AAgBJ;AAbE;EACC,eAAA;EACA,gBAAA;EACA,iCAAA;AAeH;AAZG;EACC,oCAAA;AAcJ;AAbI;EACC,WAAA;AAeL;;AATA;EACC,YAAA;AAYD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\t.map_section {\n\t\twidth: 75%;\n\t\theight: 100%;\n\t\ttransition: ease-in-out 1s;\n\t\tposition: relative;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t\t&.hide_section {\n\t\t\twidth: 0%;\n\t\t}\n\t}\n\t.sidebar_section {\n\t\tapp-venue-suggestion {\n\t\t\twidth: 100%;\n\t\t}\n\t\t@include mobile {\n\t\t\twidth: 0;\n\t\t\tapp-venue-suggestion {\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\n\t\t\t\ttransition: opacity 1s ease-in-out;\n\t\t\t}\n\t\t}\n\t\tpadding-top: 20px;\n\t\twidth: 25%;\n\t\tbox-shadow: -4.1413044929504395px 0px 56.94293975830078px 0px #0000001a;\n\t\t// background: url('../../../assets/background/background.png') no-repeat center center / 120% 120%;\n\t\tbackground-size: cover;\n\t\ttransition: width 1.5s flex-direction 2s;\n\t\toverflow: auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\ttransition: ease-in-out 1s;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\theight: 100%;\n\n\t\t&.full-width {\n\t\t\t.title {\n\t\t\t\tdisplay: none;\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: visibility 2s;\n\t\t\t}\n\t\t\tpadding: 100px 50px;\n\t\t\ttransition: all 1s;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: row;\n\t\t\t@include mobile {\n\t\t\t\tflex-direction: column !important;\n\t\t\t\twidth: 100% !important;\n\t\t\t\tpadding: 100px 20px;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t\tapp-venue-suggestion {\n\t\t\t\twidth: 24%;\n\t\t\t\t@include mobile {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n#map {\n\twidth: 100%;\n\theight: calc(100% - 115px);\n\t@include desktop {\n\t\theight: 100%;\n\t}\n\n\tz-index: 0;\n\timg {\n\t\tz-index: 1;\n\t\tmax-height: none !important;\n\t\tmax-width: none !important;\n\t}\n}\n\n.search-bar {\n\tborder-radius: 4px;\n\tline-height: 1.6;\n\twidth: 100%;\n}\n\n.search-bar > div {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tplace-items: center;\n}\n.title {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tmargin-left: 15px;\n\tmargin-top: 15px;\n}\n#search-container {\n\ttop: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n\n\tapp-venue-suggestion {\n\t\twidth: 100%;\n\t}\n}\n.search-container-input {\n\ttop: 30px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n}\n.slides-container {\n\tposition: absolute;\n\tbottom: 20px;\n\tleft: 0;\n\tright: 0;\n}\n\n.swiper-slide {\n\talign-self: flex-end;\n}\n\napp-venue-suggestion {\n\twidth: 100%;\n\t@include mobile {\n\t\twidth: 90%;\n\t}\n}\n.map-toggle {\n\tdisplay: flex;\n\tjustify-content: space-between !important;\n\talign-items: center;\n\tpadding: 5px;\n}\n.map-toggle-container {\n\theight: 48px;\n}\n\n.mode-icon {\n\tpadding: 10px;\n\theight: 25px;\n\twidth: 25px;\n}\n\n.mode-icon {\n\tbackground: #f8f8f8;\n\tfill: var(--ion-color-primary);\n\ttransition: 0.3s linear;\n}\n\n.mode-icon.selected {\n\tbackground: var(--ion-color-primary);\n\tfill: #f8f8f8;\n\ttransition: 0.3s linear;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.sidebar {\n\tapp-venue-suggestion {\n\t\tmargin: 5px auto;\n\t}\n\n\toverflow: auto;\n\theight: 100%;\n\n\t.title {\n\t\twidth: 90%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n}\n.loading-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\tbackground: black;\n\topacity: 0.5;\n\tion-spinner {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 70px;\n\t\theight: 70px;\n\t\tcolor: white;\n\t\t@include desktop {\n\t\t\twidth: 80px;\n\t\t\theight: 80px;\n\t\t}\n\t}\n}\n\n.hint {\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tpadding: 14px;\n\tbackground: white;\n\n\tp {\n\t\tfont-size: 12px;\n\t\tcolor: black;\n\t\tmargin: 0;\n\t\tpadding: 0 8px;\n\t}\n\n\tspan {\n\t\tfont-size: 14px;\n\t}\n\n\tion-icon {\n\t\theight: 44px;\n\t\twidth: 44px;\n\t\tplace-self: center;\n\t}\n}\n\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.block-venues {\n\tbackground: #f8f8f8;\n}\n.full-height {\n\theight: 100%;\n}\n#show_toggler,\n#search-container-input {\n\tposition: absolute;\n\ttop: 50px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 450px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbox-shadow: 0px 0px 50px 0px #0000001a;\n\tbackground: white;\n\tpadding: 10px;\n\ttransition: top 1s;\n\tz-index: 10;\n\t@include mobile {\n\t\twidth: 350px;\n\t\ttop: 30px;\n\t}\n\th3 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 20px;\n\t}\n\t&.move_up {\n\t\ttop: 10px;\n\t}\n}\nswiper-slide {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: auto;\n}\napp-map-search-venue {\n\twidth: 100%;\n}\n#show_toggler {\n\th3 {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 16px;\n\t}\n}\n.scroll-block {\n\tmax-height: calc(100vh - 95px);\n\t--background: transparent;\n\tbackground: transparent;\n\t--padding-start: 20px;\n\t--padding-end: 20px;\n\t// app-venue-suggestion {\n\t//   width: 100% !important;\n\t// }\n}\n.enter_address {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 80%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t&.hide-item {\n\t\topacity: 0;\n\t}\n\t@include mobile {\n\t\ttop: 120px;\n\t}\n\t.wrapper_input {\n\t\tbackground: white;\n\t\tborder-radius: 16px;\n\t\tz-index: 99;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 5px 10px;\n\t\twidth: 100%;\n\t}\n\tion-input {\n\t\tfont-size: 18px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\t.pac-container {\n\t\tbackground: white;\n\t\twidth: 100%;\n\t\tpadding: 8px 20px !important;\n\t\tmargin-top: 5px;\n\t\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;\n\t\tborder-radius: 4px !important;\n\t\tborder: none !important;\n\n\t\t.pac-item {\n\t\t\tborder-top: none !important;\n\t\t\tfont-family: Subway, sans-serif;\n\t\t\tpadding: 16px 0;\n\t\t\tline-height: 1 !important;\n\t\t\tfont-size: 14px !important;\n\t\t\tborder-bottom: 0.5px solid #e8e8e8;\n\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\n\t\t\t.pac-matched {\n\t\t\t\tfont-family: Subway-bold, sans-serif;\n\t\t\t}\n\t\t}\n\t}\n}\n.wrapper_for_types {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding: 15px;\n\tmax-height: fit-content;\n\tposition: relative;\n\toverflow-wrap: break-word;\n\tword-break: break-word;\n\tword-wrap: break-word;\n\t.show-error-item {\n\t\tposition: absolute;\n\t\tbottom: -60px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tz-index: 999;\n\t\twidth: fit-content;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tbackground: #ed6958;\n\t\tjustify-content: center;\n\t\tpadding: 10px 15px;\n\t\tborder-radius: 10px;\n\t\tion-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: -10px;\n\t\t}\n\t\th3 {\n\t\t\tfont-size: 14px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-left: 15px;\n\t\t\tcolor: white;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: white;\n\t\t}\n\t}\n\t&.wrapper_for_types_desktop {\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.item {\n\t\twidth: 25%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tbackground: transparent;\n\t\tdiv {\n\t\t\tpadding: 10px;\n\t\t\tbackground: #f3f3f3;\n\t\t\tborder-radius: 50%;\n\t\t\toverflow: hidden;\n\t\t\twidth: 50px;\n\t\t\theight: 50px;\n\t\t\ttransition: background 0.3s ease-in-out;\n\t\t\tion-icon {\n\t\t\t\twidth: 30px;\n\t\t\t\theight: 30px;\n\t\t\t\ttransition: fill 0.3s ease-in-out;\n\n\t\t\t\tfill: var(--ion-color-secondary);\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tfont-size: 16px;\n\t\t\tmargin-top: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t&.active {\n\t\t\tdiv {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tion-icon {\n\t\t\t\t\tfill: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.show-error {\n\topacity: 0.5;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
